import { useState, useEffect } from 'react';
import { debounce } from 'app/utils/helpers';
import mediaQueries from 'app/utils/mediaQueries';

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(mediaQueries.is_large_up());

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setIsDesktop(mediaQueries.is_large_up());
    }, 100);

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  return { isDesktop };
};

export default useIsDesktop;
